import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { routes } from "./listings.routing.module";
import { SharedModule } from "../../shared/shared.module";
import { ListingsFeatureComponent } from "./listings.component";
import { ListingsService } from "../../core/services";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [ListingsFeatureComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild(),
    RouterModule.forChild(routes)
  ],
  exports: [],
  providers: [ListingsService]
})
export class ListingsFeatureModule {}
